import { useMemo } from "react";

export const useEnvironment = () => {
  const isDev = useMemo(() => {
    return import.meta.env.VITE_APP_ENV === "dev";
  }, []);

  const isStaging = useMemo(() => {
    return import.meta.env.VITE_APP_ENV === "staging";
  }, []);

  const isProd = useMemo(() => {
    return import.meta.env.VITE_APP_ENV === "prod";
  }, []);

  return { isDev, isStaging, isProd };
};
